import { Action, ThunkAction } from '../types';

// TODO: KIRBY-10064 - id-auth returns option to redirect to MPUI passkeys page
type MfaPromoteChoice = 'edit_mfa' | 'dismiss';

export const handleMfaPromoteUserSelection =
  (choice: MfaPromoteChoice, queryParams?: string | null): ThunkAction =>
  dispatch => {
    const loginPathWithErrorMessage = () => {
      const params = new URLSearchParams({
        errorCode: 'invalid.session.token',
        prompt: 'true',
      }).toString();
      return `/login?${params}`;
    };
    return fetch(`/v2/mfa/promote${queryParams || ''}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ choice }),
    })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error(`${response.status} ${response.statusText}: /v2/mfa/promote`);
        }
      })
      .then(body => {
        const redirectUrl = body?.redirectTo || loginPathWithErrorMessage();
        dispatch(mfaPromoteRedirect(redirectUrl));
      })
      .catch(() => {
        dispatch(mfaPromoteRedirect(loginPathWithErrorMessage()));
      });
  };

export const mfaPromoteRedirect = (redirectTo: string): Action => ({
  type: 'MFA_PROMOTE_REDIRECT',
  redirectTo,
});
